import React, { useState, useEffect, Fragment, useRef } from "react";
import ReactDom, { unmountComponentAtNode, createPortal } from "react-dom";
import Form from "react-bootstrap/Form";
import { withAITracking } from "@microsoft/applicationinsights-react-js";
import { reactPlugin } from "../../utils/AppInsights";
import VGPopUp from "../Controls/VGPopUp";
import { utils, ResponseCode, LoginUserType } from "../../utils/Utils";
import { AsyncAjaxGet, AsyncAjaxPost } from "../Common/AsyncAjaxService";
import Loader from "../Common/Loader";
import MultiSelect from "../Controls/MultiSelect";
import FileUpload from "../Controls/FileUpload";
import EditCategoriesStylePopup from "./EditCategoriesStylePopup";
import store from '../../app/store'
import Toast from "components/WebDesigner/Toast";
import $ from "jquery";
import useGenerateToken from "components/Hook/useGenerateToken";

const AddEditStylePopup = (props) => {
    const styleName = useRef(null);
    const { ReactBusinessId, ReactUserID } = store.getState().Business;
    const { access_token } = store.getState().Token;

    const VagaroAPIEnum = {
        StyleCategorySubCategory: "style/stylecategorysubcategory",
        SaveStyle: "style/saveupdate",
        DuplicateStyle: "style/duplicate",
        StyleUploadImage: "style/uploadstyleimage",
        DeleteUploadImage: "style/deleteuploadfile",
    };
    const StyleImageSize = {
        width: 1920,
        height: 1280
    }
    const cardImgPath = window.location.href.indexOf("vagaro.com") > 0 ? ("https://d396040dc4cf62cf5770-d11e112dbdab6afc64c448f17b56c3c3.ssl.cf2.rackcdn.com/WB/"):("https://f745786de3dd98dac855-36e09dc6f87385bab9d0e7ff5c0d38c7.ssl.cf2.rackcdn.com/WB/");
    const CountMatches = (stateValue) => {
        var val = "";
        var num = 0;
        const regexfornumber = /^(.*?Copy)(\s\d+)?$/;
        const matchesnumber = stateValue.match(regexfornumber);
        const containsCopy = /\bCopy\b/.test(stateValue);

        if (matchesnumber && matchesnumber[2]) {
            val = stateValue.replace(/Copy\s\d+$/, '').trim();
            num = 1;
        }
        else if (containsCopy) {
            val = stateValue.replace(" Copy", "");
        }
        else {
            val = stateValue.trim();
            //num = 1; //first time not required
        }
        // var SameStyleName = props.allStyleName.filter(
        //     (col) => col.styleName.replace(regex, '').trim() === val
        // );
        var SameStyleName = props.allStyleName.filter((col) => col.styleName.toLowerCase().includes(`${val.toLowerCase()}`) === true)
        const newNumber = SameStyleName.length;
        if (newNumber == 1) {
            return `${val} ${"Copy"}`;
        }
        else {
            return `${val} ${"Copy"} ${newNumber}`;
        }
    };



    const [allcategory, setCategory] = useState([]);
    const [allGroupcategory, setallGroupcategory] = useState([]);
    const [allSubCategory, setSubCategory] = useState([]);
    const SubCategorys = useRef([]);
    const CategoryID = useRef([]);
    const SubCategoryID = useRef([]);
    const styleId = props.StyleID;
    const isDuplicate = props.isDuplicate;
    const isBuilderPage = props.isBuilderPage;
    const styleContent = props.StyleContent;
    const StyleDetails = props.styleDetails;
    const [isNewest, setTsNewest] = useState(typeof StyleDetails != undefined && StyleDetails != null ? StyleDetails.isNewest : false);

    const [filterSubCategory, setFilterSubCategory] = useState([]);
    const [categoryId, setCategoryId] = useState([]);
    const [subCategoryId, setSubCategoryId] = useState([]);

    const [styleTitle, setstyleTitle] = useState((isDuplicate === true && isBuilderPage == false) ? (typeof StyleDetails != undefined && StyleDetails != null ? CountMatches(StyleDetails.styleTitle) : "") : typeof StyleDetails != undefined && StyleDetails != null ? StyleDetails.styleTitle : "");
    const [styleImage, setstyleImage] = useState(typeof StyleDetails != undefined && StyleDetails != null ? StyleDetails.styleImage : "");

    const [isLoading, setLoading] = useState(false);

    const [isValidCategoryId, setIsValidCategoryId] = useState(true);
    const [isValidSubCategoryId, setIsValidSubCategoryId] = useState(true);
    const [isValidStyleTitle, setisValidStyleTitle] = useState(true);
    const [isValidStyleImage, setisValidStyleImage] = useState(true);
    const [isValidStyleSameTitle, setisValidStyleSameTitle] = useState(true);

    const TemUploadImageReq = (
        filename,
        Base64
    ) => {
        const Requestdata = {};
        Requestdata.FileName = filename;
        Requestdata.base64image = "url(\"data:image/png;base64," + Base64 + "\")";
        Requestdata.Foldername = "WB";
        return Requestdata;
    };

    const readFile = (file, onLoadCallback) => {
        var reader = new FileReader();
        reader.onload = onLoadCallback;
        reader.readAsDataURL(file);
    };
    const imageSize = (filename, callback) => {

        var img = new Image();
        img.onload = function () {
            var myResult = {
                width: img.width,
                height: img.height,
            };
            callback(myResult);
        };
        img.src = filename;
        img.onerror = function () {
            var myResult = {
                width: -101,
                height: -101,
            };
            callback(myResult);
        };
    };

    const StylesUpload = async (
        filename,
        Base64,
        height,
        width,
        filesDetails,
        divMain
    ) => {
        var isvalid = false;
        const access_token = await useGenerateToken(props.dispatch);
        readFile(filesDetails, function (e) {
            imageSize(e.target.result, function () {
                if (height === -101 && width === -101) {
                    const TitleEnum = "Alert!";
                    const BodyEnum =
                        "The image you have uploaded seems to be corrupted. Please upload another image.";
                    utils.ShowAlert(TitleEnum, BodyEnum, "OpenDialog2");
                } else if (
                    (height === StyleImageSize.height && width === StyleImageSize.width && height <= StyleImageSize.height && width <= StyleImageSize.width) ||
                    (height === StyleImageSize.height && width === StyleImageSize.width)
                ) {
                    isvalid = true;
                } else {
                    const TitleEnum = "Incorrect Image Size";
                    const BodyEnum = `The width and height required for the image is ${StyleImageSize.width}x${StyleImageSize.height}`;
                    utils.ShowAlert(TitleEnum, BodyEnum, "OpenDialog2");
                }

                if (isvalid) {
                    if (utils.Validate(access_token)) {
                        setLoading(true);
                        const Requestdata = TemUploadImageReq(
                            filename,
                            Base64
                        );
                        AsyncAjaxPost(
                            VagaroAPIEnum.StyleUploadImage,
                            Requestdata,
                            access_token,
                            function onSuccess(data) {
                                try {
                                    if (data != null && data.data != null && data.data.data != null) {
                                        setstyleImage(data.data.data);
                                        setisValidStyleImage(true);
                                        $('.drop-file-upload-lg').prop('title', "");
                                    }
                                    setLoading(false);
                                } catch (error) {
                                    setLoading(false);
                                }
                            },
                            function OnError() {
                                setLoading(false);
                            }
                        );
                    }
                    else {
                        utils.ShowAlert("Message", "Please reload this page and try again.", "OpenDialog");
                    }
                }
            });
        });

    };

    const SaveStylesUploadImage = (filename, Base64, height, width, filesDetails, divMain) => {
        StylesUpload(filename, Base64, height, width, filesDetails, false);
    };
    const categorySubCategoryBinding = async () => {
        if (typeof ReactBusinessId !== 'undefined' && ReactBusinessId >= 0 && utils.Validate(access_token)) {
            const Requestdata = {
                StyleId: props.StyleID,
                CatagoryId: typeof props.selectionCategoryId != 'undefined' && props.selectionCategoryId.current ? props.selectionCategoryId.current : ""

            };

            setLoading(true)
            await AsyncAjaxPost(
                VagaroAPIEnum.StyleCategorySubCategory,
                Requestdata,
                access_token,
                function onSuccess(data) {
                    try {
                        if (
                            data != null &&
                            data.data != null &&
                            data.data.responseCode == ResponseCode.Success
                        ) {
                            if (data != null && data.data != null && data.data.data != null && data.data.data.category != null) {
                                                                // var catID = data.data.data.category.filter((data) => data.isChecked === true).join(",")  
                                var catID = data.data.data.category.map((val) => val.isChecked ? val.id : "");
                                var parentCat = data.data.data.category.filter(x => x.parentCategoryId == "");
                                var GroupProp = []
                                catID = catID.filter((val) => val !== "")
                                setCategoryId(catID);
                                CategoryID.current = catID;
                                setCategory(data.data.data.category);
                                parentCat.map( cat =>
                                    GroupProp.push({
                                        "text":cat.name,
                                        "children":data.data.data.category.filter(val => val.parentCategoryId == cat.id).map((val)=> ({id:val.id , text: val.name}))
                                    })
                                )
                                setallGroupcategory(GroupProp)
                            }
                            else {
                                setCategory([]);
                            }
                            if (data != null && data.data != null && data.data.data != null && data.data.data.subCategory != null) {
                                var subcatID = data.data.data.subCategory.map((data) => data.isChecked ? data.id : "")
                                subcatID = subcatID.filter((val) => val !== "")
                                setFilterSubCategory(subcatID);
                                setSubCategoryId(subcatID);
                                SubCategoryID.current = subcatID;
                                SubCategorys.current = data.data.data.subCategory;
                                setSubCategory(data.data.data.subCategory);
                            }
                            else {
                                setSubCategory([]);
                                setFilterSubCategory([]);
                            }

                            setLoading(false)
                        }
                    }
                    catch (error) {
                        utils.appInsightTrack(
                            ReactBusinessId,
                            ReactUserID,
                            "Get Category SubCategory",
                            null,
                            ""
                        );
                    }
                },
                function OnError() {
                    utils.appInsightTrack(
                        ReactBusinessId,
                        ReactUserID,
                        "Get Category SubCategory",
                        null,
                        ""
                    );
                }
            );
        }
    };
    useEffect(() => {
        if (styleName.current) {
            styleName.current.focus();
        }
    }, [])

    const first = useRef(true)
    useEffect(() => {
        if (first.current) {
            categorySubCategoryBinding()
            first.current = false;
        }

    }, [])


    const EditStyleImageConfirmation = (filename, Base64) => {
        $("#generalupload").click();
    }
    const DeleteStyleImageConfirmation = (filename, Base64) => {
        return ReactDom.render(
            <VGPopUp
                id={"DeleteStyleImage"}
                show={true}
                onHide={PopupCloseConfirmation}
                title={"Delete Style Image"}
                dialogClassName="cancelauto-renew-alert"
                body={
                    <div className="alertContent">
                        <p>Your style image will be removed from the database. Are you sure you want to remove image?</p>
                    </div>
                }
                footer={
                    <Fragment>
                        <button className="w-button w-button-secondary" onClick={() => PopupCloseConfirmation()}>Cancel</button>
                        <button className="w-button w-button-destructive-outline" onClick={() => DeleteStyleImage(filename, Base64)}>Delete</button>
                    </Fragment >
                }
                isRemoveTabModalIndex={false}
                isShowFooter={true}
                size={"modal-sm"}
                backdrop={true}
            />,
            document.getElementById("OpenDialog1"));
    }

    const DeleteStyleImage = async (
        filename
    ) => {
        const access_token = await useGenerateToken(props.dispatch);
        if (utils.Validate(access_token)) {
            PopupCloseConfirmation();
            setLoading(true);
            const Requestdata = {};
            Requestdata.FileName = filename;
            Requestdata.Foldername = "WB";
            await AsyncAjaxPost(
                VagaroAPIEnum.DeleteUploadImage,
                Requestdata,
                access_token,
                function onSuccess(data) {
                    try {
                        if (data !== null && data.data !== null && data.data.data !== null && data.data.data === true) {
                            setstyleImage("");
                            setisValidStyleImage(false);

                        }
                        setLoading(false);
                    } catch (error) {
                        setLoading(false);
                    }
                },
                function OnError() {
                    setLoading(false);
                }
            );
        }
        else {
            utils.ShowAlert("Message", "Please reload this page and try again.", "OpenDialog");
        }
    };

    const onChangeCategory = (categoryId) => {
        if (categoryId.length > 0) {
            var ArrSubCategory = [];
            var subcatagorys = SubCategorys.current;
            var subcatagoryid = SubCategoryID.current;
            categoryId.map((item) => {
                var SubCategoryList = subcatagorys.filter(
                    (col) => col.parentCategoryId === item.trim()
                );
                if (SubCategoryList.length > 0) {
                    setFilterSubCategory(subcatagorys);
                    // setFilterSubCategory(prevfilterSubCategory => ([...prevfilterSubCategory, ...SubCategoryList]));
                    if (typeof styleId != undefined && styleId != "" && styleId != null) {
                        SubCategoryList.map((subcategoryitem) => {
                            var FilterSubCategoryIds = subcatagoryid.filter(
                                (col) => col === subcategoryitem.id.trim()
                            );
                            if (FilterSubCategoryIds.length > 0) {
                                ArrSubCategory.push(FilterSubCategoryIds[0]);
                            }
                        });
                    }
                }
            })
            if (typeof styleId != undefined && styleId != "" && styleId != null) {
                setSubCategoryId(ArrSubCategory);
                SubCategoryID.current = ArrSubCategory;
            }
            setIsValidSubCategoryId(true);
        }
        else {
            setFilterSubCategory([]);
            setIsValidSubCategoryId(true);
        }
    }

    const categorySelect = (categoryid) => {
        var ArrayCateID;
        if (categoryid != "") {
            ArrayCateID = categoryid.split(",").map(function (item) {
                return item.trim();
            });
        }
        else {
            ArrayCateID = [];
        }
        setCategoryId(ArrayCateID);
        CategoryID.current = ArrayCateID;
        if (ArrayCateID.length > 0) {
            setIsValidCategoryId(true);
        }
        else {
            setIsValidCategoryId(false);
        }
    }

    const subCategorySelect = (subCategoryid) => {
        var ArraySubCateID;
        if (subCategoryid != "") {
            ArraySubCateID = subCategoryid.split(",").map(function (item) {
                return item.trim();
            });
        }
        else {
            ArraySubCateID = [];
        }
        if (ArraySubCateID.length > 0) {
            setIsValidSubCategoryId(true);
        }
        else {
            setIsValidSubCategoryId(false);
        }
        setSubCategoryId(ArraySubCateID);
        SubCategoryID.current = ArraySubCateID;
    }

    useEffect(() => {
        var allCalegoryId = allcategory.map(val => val.id);
        onChangeCategory(allCalegoryId);
    }, [allSubCategory]);

    const SaveStyles = async () => {
        const access_token = await useGenerateToken(props.dispatch);
        if (props.UserType !== LoginUserType.VagaroAdmin) {
            utils.ShowAlert("Alert", "You do not have permission to edit style.", "OpenDialog");
        }
        else {
            if (utils.Validate(access_token)) {
                if (categoryId.length === 0
                    || subCategoryId.length === 0
                    || (typeof styleTitle === 'undefined' || styleTitle === "" || styleTitle === null)
                    || (typeof styleImage === 'undefined' || styleImage === "" || styleImage === null)) {

                    if (categoryId.length === 0) {
                        setIsValidCategoryId(false);
                    }
                    else {
                        setIsValidCategoryId(true);
                    }
                    if (subCategoryId.length === 0) {
                        setIsValidSubCategoryId(false);
                    }
                    else {
                        setIsValidSubCategoryId(true);
                    }
                    if ((typeof styleTitle === 'undefined' || styleTitle === "" || styleTitle === null)) {
                        setisValidStyleTitle(false);
                    }
                    else {
                        setisValidStyleTitle(true);
                    }
                    if ((typeof styleImage === 'undefined' || styleImage === "" || styleImage === null)) {
                        setisValidStyleImage(false);
                    } else {
                        setisValidStyleImage(true);
                    }
                    return;
                }
                var SameStyleName;

                if (typeof styleId !== 'undefined' && styleId !== "" && styleId !== null) {
                    SameStyleName = props.allStyleName.filter(
                        (col) => col.styleName.toLowerCase() === styleTitle.toLowerCase() && col.styleId !== styleId
                    );
                }
                else {
                    SameStyleName = props.allStyleName.filter(
                        (col) => col.styleName.toLowerCase() === styleTitle.toLowerCase()
                    );
                }
                if (SameStyleName !== 'undefined' && SameStyleName !== "" && SameStyleName !== null && SameStyleName.length > 0) {
                    setisValidStyleSameTitle(false);
                } else {

                    setLoading(true);
                    const Requestdata = {};
                    if (typeof styleId != 'undefined' && styleId != "" && styleId != null) {
                        Requestdata.ID = styleId;
                    }
                    else {
                        Requestdata.ID = "";
                    }
                    Requestdata.PartnerId = 0;
                    Requestdata.CategoryId = categoryId;
                    Requestdata.SubCategoryId = subCategoryId;
                    Requestdata.StyleTitle = styleTitle;
                    Requestdata.StyleDescription = "";
                    Requestdata.StyleImage = styleImage;
                    Requestdata.IsNewest = isNewest;
                    Requestdata.IsPopular = false;
                    Requestdata.ModifyBy = ReactUserID;
                    await AsyncAjaxPost(
                        VagaroAPIEnum.SaveStyle,
                        Requestdata,
                        access_token,
                        function onSuccess(data) {
                            try {
                                if (
                                    data != null &&
                                    data.data != null &&
                                    data.data.responseCode == ResponseCode.Success
                                ) {
                                    if (data != null && data.data != null && data.data.data != null && data.data.data.status === true) {
                                        PopupClose();
                                        setLoading(false);
                                        if (!isBuilderPage) {
                                            props.UdateStyleState("Edit", Requestdata);
                                            props.IsMessageOpen(true);
                                            { Requestdata.ID == "" && props.Message("Style has been created successfully.") };
                                            { Requestdata.ID !== "" && props.Message("Style has been updated successfully.") };
                                            props.allStyleNameOperation(typeof styleId != 'undefined' && styleId != "" && styleId != null ? "Edit" : "Add", styleId, styleTitle);
                                        }

                                        if (props.onSave) {
                                            props.onSave();
                                        }
                                    }
                                    else {
                                        PopupClose();
                                        setLoading(false);
                                    }
                                }
                                else {
                                    PopupClose();
                                    setLoading(false);
                                }

                            }
                            catch (error) {
                                setLoading(false);
                                utils.appInsightTrack(
                                    ReactBusinessId,
                                    ReactUserID,
                                    "Save/Update Admin Style",
                                    Requestdata,
                                    ""
                                );
                            }
                        },
                        function OnError() {
                            setLoading(false);
                            utils.appInsightTrack(
                                ReactBusinessId,
                                ReactUserID,
                                "Save/Update Admin Style",
                                Requestdata,
                                ""
                            );
                        }
                    );
                }
            }
            else {
                utils.ShowAlert("Message", "Please reload this page and try again.", "OpenDialog");
            }
            if (typeof styleId == 'undefined' || styleId == "" || styleId == null) {
                if (categoryId.length > 0) {
                    props.getSubCategory(categoryId[0].toString())
                }
            }
        }
    }

    const DuplicateStyles = async () => {
        const access_token = await useGenerateToken(props.dispatch);
        if (props.UserType !== LoginUserType.VagaroAdmin) {
            utils.ShowAlert("Alert", "You do not have permission to duplicate style.", "OpenDialog");
        }
        else {
            if (utils.Validate(access_token)) {
                if (categoryId.length === 0
                    || subCategoryId.length === 0
                    || (typeof styleTitle === 'undefined' || styleTitle === "" || styleTitle === null)
                    || (typeof styleImage === 'undefined' || styleImage === "" || styleImage === null)) {

                    if (categoryId.length === 0) {
                        setIsValidCategoryId(false);
                    }
                    else {
                        setIsValidCategoryId(true);
                    }
                    if (subCategoryId.length === 0) {
                        setIsValidSubCategoryId(false);
                    }
                    else {
                        setIsValidSubCategoryId(true);
                    }
                    if ((typeof styleTitle === 'undefined' || styleTitle === "" || styleTitle === null)) {
                        setisValidStyleTitle(false);
                    }
                    else {
                        setisValidStyleTitle(true);
                    }
                    if ((typeof styleImage === 'undefined' || styleImage === "" || styleImage === null)) {
                        setisValidStyleImage(false);
                    } else {
                        setisValidStyleImage(true);
                    }
                    return;
                }
                var SameStyleName = props.allStyleName.filter(
                    (col) => col.styleName.toLowerCase() === styleTitle.toLowerCase()
                );
                if (SameStyleName !== 'undefined' && SameStyleName !== "" && SameStyleName !== null && SameStyleName.length > 0) {
                    setisValidStyleTitle(false);
                } else {

                    setLoading(true);
                    const Requestdata = {};
                    Requestdata.ID = styleId;
                    Requestdata.ReactBusinessId = ReactBusinessId;
                    Requestdata.PartnerId = 0;
                    Requestdata.CategoryId = categoryId;
                    Requestdata.SubCategoryId = subCategoryId;
                    Requestdata.StyleTitle = styleTitle;
                    Requestdata.StyleDescription = "";
                    Requestdata.StyleContent = styleContent;
                    Requestdata.StyleImage = styleImage;
                    Requestdata.IsNewest = isNewest;
                    Requestdata.IsPopular = false;
                    Requestdata.CreatedBy = ReactUserID;
                    await AsyncAjaxPost(
                        VagaroAPIEnum.DuplicateStyle,
                        Requestdata,
                        access_token,
                        function onSuccess(data) {
                            try {
                                if (
                                    data != null &&
                                    data.data != null &&
                                    data.data.responseCode == ResponseCode.Success
                                ) {
                                    if (data != null && data.data != null && data.data.data != null && data.data.data.styleId !== undefined && data.data.data.styleId !== null) {
                                        PopupClose();
                                        setLoading(false);
                                        if (!isBuilderPage) {
                                            props.StyleBinding(false, true, false);
                                            props.IsMessageOpen(true);
                                            props.Message("Duplicate style has been created successfully.");
                                            props.allStyleNameOperation("Add", data.data.data.styleId, styleTitle);
                                        }
                                        else {
                                            Toast("Style has been created successfully.");
                                            setTimeout(() => {
                                                window.location.href = "/"
                                            }, 500);
                                        }
                                    }
                                    else {
                                        PopupClose();
                                        setLoading(false);
                                    }
                                }
                                else {
                                    PopupClose();
                                    setLoading(false);
                                }

                            }
                            catch (error) {
                                setLoading(false);
                                utils.appInsightTrack(
                                    ReactBusinessId,
                                    ReactUserID,
                                    "Duplicate Admin Style",
                                    Requestdata,
                                    ""
                                );
                            }
                        },
                        function OnError() {
                            setLoading(false);
                            utils.appInsightTrack(
                                ReactBusinessId,
                                ReactUserID,
                                "Duplicate Admin Style",
                                Requestdata,
                                ""
                            );
                        }
                    );
                }
            }
            else {
                utils.ShowAlert("Message", "Please reload this page and try again.", "OpenDialog");
            }
        }
    }

    const styleNameValidation = (Title) => {
        setstyleTitle(Title);
        if (Title === "") {
            setisValidStyleTitle(false);
            setisValidStyleSameTitle(true);
        }
        else {
            if (isBuilderPage === false && typeof styleId !== 'undefined' && styleId !== null && styleId !== "") {
                var SameStyleName = props.allStyleName.filter(
                    (col) => col.styleName.toLowerCase() === Title.toLowerCase() && col.styleId !== styleId
                );
            }
            else {
                SameStyleName = props.allStyleName.filter(
                    (col) => col.styleName.toLowerCase() === Title.toLowerCase()
                );
            }
            if (SameStyleName !== 'undefined' && SameStyleName !== "" && SameStyleName !== null && SameStyleName.length !== 0) {
                if (SameStyleName[0].styleName.toLowerCase() === Title.toLowerCase()) {
                    setisValidStyleSameTitle(false);
                    setisValidStyleTitle(true);
                }
                else {
                    setisValidStyleSameTitle(true);
                }
            }
            else {
                setisValidStyleSameTitle(true);
            }
            setisValidStyleTitle(true);
            const result = Title.replace(/[#%*<>|\/]*/g, "");
            setstyleTitle(result);
        }
    }
    const DeleteCat = (id) => {
        var catagoryes = SubCategorys.current.filter((data) => data.id !== id);
        SubCategorys.current = catagoryes;
        setSubCategory(catagoryes);
    }
    const CloseEditCat = async () => {
        const access_token = await useGenerateToken(props.dispatch);
        if (typeof ReactBusinessId !== 'undefined' && ReactBusinessId >= 0 && utils.Validate(access_token)) {
            const Requestdata = {
                StyleId: ""
            };
            setLoading(true);
            await AsyncAjaxPost(
                VagaroAPIEnum.StyleCategorySubCategory,
                Requestdata,
                access_token,
                function onSuccess(data) {
                    try {
                        if (
                            data != null &&
                            data.data != null &&
                            data.data.responseCode == ResponseCode.Success
                        ) {
                            if (data != null && data.data != null && data.data.data != null && data.data.data.category != null) {
                            }
                            if (data != null && data.data != null && data.data.data != null && data.data.data.subCategory != null) {
                                SubCategorys.current = data.data.data.subCategory;
                                setSubCategory(data.data.data.subCategory);
                            }
                            setLoading(false);

                        }
                    }
                    catch (error) {
                        setLoading(false);
                        utils.appInsightTrack(
                            ReactBusinessId,
                            ReactUserID,
                            "Get Category SubCategory",
                            null,
                            ""
                        );
                    }
                },
                function OnError() {
                    setLoading(false);
                    utils.appInsightTrack(
                        ReactBusinessId,
                        ReactUserID,
                        "Get Category SubCategory",
                        null,
                        ""
                    );
                }
            );
        }
    }


    const EditCategoriesStyle = async () => {
        const access_token = await useGenerateToken(props.dispatch);
        if (props.UserType !== LoginUserType.VagaroAdmin) {
            utils.ShowAlert("Alert", "You do not have permission to edit category.", "OpenDialog");
        }
        else {
            unmountComponentAtNode(document.getElementById("OpenDialog1"));
            return ReactDom.render(
                <EditCategoriesStylePopup
                    {...props}
                    categoryId={categoryId}
                    CategoryID={CategoryID.current}
                    category={allcategory}
                    subCategory={allSubCategory}
                    styleId={styleId}
                    onClose={() => CloseEditCat()}
                    onDelete={DeleteCat}
                    filterSubCategory={filterSubCategory}
                    setFilterSubCategory={setFilterSubCategory}
                    categorySubCategoryBinding={props.categorySubCategoryBinding}
                    selectionCategoryId={props.selectionCategoryId}
                    selectionSubCategoryId={props.selectionSubCategoryId}
                    dispatch={props.dispatch}
                    SubCategorys={SubCategorys}
                    SubCategoryID={SubCategoryID}
                    access_token={access_token}
                />,
                document.getElementById("OpenDialog1")
            )
        }
    }

    const EditStyleBody = () => {
        return (
            <div className="form-content">
                {isLoading && <Loader />}
                <Form>
                    <Form.Group className={`form-row ${!isValidCategoryId && "form-row-invalid"}`}>
                        <Form.Label>Business Type: <span style={{ color: "red" }}>*</span></Form.Label>
                        <MultiSelect
                            className="vg-custom-select employee-vg-select"
                            classNamePrefix="vg-select"
                            aria-label="Default select example"
                            options={allGroupcategory}
                            subCatOptions={allSubCategory}
                            onChange={(category) => {
                                categorySelect(category);
                            }}
                            defaultValue={categoryId}
                            isMulti
                            placeholder="Select Type"
                            ControlID="ddlcategory"
                            searchInputPlaceholder="Search"
                            GroupSelect
                        />
                        {!isValidCategoryId && <Form.Control.Feedback type="invalid">Please select business type</Form.Control.Feedback>}
                    </Form.Group>
                    <Form.Group className={`form-row ${!isValidSubCategoryId && "form-row-invalid"}`}>
                        <Form.Label><div>Style Category: <span style={{ color: "red" }}>*</span>
                        </div>
                        </Form.Label>
                        <MultiSelect
                            className="vg-custom-select employee-vg-select"
                            classNamePrefix="vg-select"
                            aria-label="Default select example"
                            options={filterSubCategory}
                            isHaveAddnewCategory={true}
                            addNewcategoryFun={() => {
                                EditCategoriesStyle();
                            }}
                            onChange={(subcategory) => {
                                subCategorySelect(subcategory);
                            }}
                            defaultValue={subCategoryId}
                            isMulti
                            placeholder="Select Style Category"
                            ControlID="ddlsubcategory"
                            searchInputPlaceholder="Search"
                            isValidSubCategoryId={isValidSubCategoryId}
                        />
                        {!isValidSubCategoryId && <Form.Control.Feedback type="invalid">Please select style category</Form.Control.Feedback>}

                    </Form.Group>
                    <Form.Group className={`form-row ${(!isValidStyleTitle || !isValidStyleSameTitle) && "form-row-invalid"}`}>
                        <Form.Label>Style Name: <span style={{ color: "red" }}>*</span></Form.Label>
                        <Form.Control type="text" ref={styleName} maxLength={50} placeholder="Enter Style Name" defaultValue={styleTitle} onChange={(e) => { e.target.value = e.target.value.replace(/[\uD800-\uDFFF].|[\u200D\uFE0F#%*<>|\/]*/g, ""); styleNameValidation(e.target.value.trim()); }} />
                        {!isValidStyleSameTitle ? <Form.Control.Feedback type="invalid">Style name already exist</Form.Control.Feedback> : <Form.Control.Feedback type="invalid">Please enter style name</Form.Control.Feedback>}
                    </Form.Group>

                    <Form.Group className="form-row">
                        <div className="row">
                            <div className="col-sm-6">
                                <Form.Check
                                    type="switch" className="vg-switch-checkboxhtml"
                                    id="custom-switch1"
                                    label="Set as New"
                                    onChange={(e) => { setTsNewest(e.target.checked) }}
                                    defaultChecked={isNewest}
                                />
                            </div>
                        </div>
                    </Form.Group>
                    <Form.Group className={`form-row ${!isValidStyleImage && "form-row-invalid"}`}>
                        <Form.Label>Style Image: <span style={{ color: "red" }}>*</span></Form.Label>
                        {styleImage !== "" &&
                            <div className="drop-file-upload tempalteimg py-t8 uploaded drop-file-upload-lg" style={{ backgroundImage: `url('${cardImgPath + styleImage}')` }}>
                                <div className="showdelete d-flex flex-column">
                                    <div className="p-2">
                                        <a onClick={() => EditStyleImageConfirmation(cardImgPath + styleImage)}>Edit</a>
                                    </div>
                                    <div className="p-2">
                                        <a onClick={() => DeleteStyleImageConfirmation(styleImage)}>Delete</a>
                                    </div>
                                </div>
                            </div>
                        }
                        <div className={`drop-file-upload drop-file-upload-lg ${!isValidStyleImage && "invalid"}`} style={{ display: styleImage !== "" ? "none" : "flex" }}>
                            <i className="far fa-cloud-upload" />
                            <span className="upload-note">
                                Drag and drop files here or
                            </span>
                            <span className="upload-trigger">
                                Choose File
                            </span>
                            <FileUpload
                                id="styleupload"
                                height={StyleImageSize.height}
                                width={StyleImageSize.width}
                                Message="The width and height required for the image is 1920x1280"
                                ValidFileExtensionMessage="Upload a valid PNG, HEIC, JPEG or JPG image."
                                FileExtension="/(gif|png|jpg|jpeg|GIF|PNG|JPG|JPEG)$/i"
                                savecdn={SaveStylesUploadImage}
                                setLoading={setLoading}
                            ></FileUpload>
                        </div>
                        <div className="form-text">
                            Upload a {StyleImageSize.width} x {StyleImageSize.height} pixel style image.
                        </div>
                        {!isValidStyleImage && <Form.Control.Feedback type="invalid" className="abovehelpmsg">Please upload style image</Form.Control.Feedback>}
                    </Form.Group>
                </Form>
            </div >

        )
    }

    const EditStyleFooter = () => {
        return (
            <Fragment>
                <button className="w-button w-button-secondary" onClick={() => PopupClose()}>Cancel</button>
                {isDuplicate &&
                    <button className="w-button w-button-primary" onClick={() => DuplicateStyles()}>{isBuilderPage ? "Save as Style" : "Duplicate"}</button>
                }
                {!isDuplicate &&
                    <button className="w-button w-button-primary" onClick={() => SaveStyles()}>Save</button>
                }
            </Fragment>
        )
    }

    const PopupClose = () => {
        unmountComponentAtNode(document.getElementById("OpenDialog"));
    };

    const PopupCloseConfirmation = () => {
        unmountComponentAtNode(document.getElementById("OpenDialog1"));
    };

    return createPortal(
        <>
            {allcategory.length === 0 ? <Loader /> :

                <VGPopUp
                    id={"EditStylePopup"}
                    show={true}
                    title={isDuplicate ? (isBuilderPage === false ? "Duplicate Style" : "Save As Style") : (typeof styleId != 'undefined' && styleId != "" && styleId != null ? "Edit Style" : "Add Style")}
                    onHide={PopupClose}
                    size="sm"
                    body={EditStyleBody()}
                    dialogClassName="vg-w480"
                    footer={EditStyleFooter()}
                    isShowFooter={true}
                    backdrop={true}
                    isRemoveTabModalIndex={true}
                />}
        </>
        ,
        document.getElementById("OpenDialog")
    )
}

export default withAITracking(reactPlugin, AddEditStylePopup);